import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableReviewTerms = loadable(() => import('./ReviewTerms'), {
  fallback: <LoadingScreen />,
});

export default LoadableReviewTerms;
